import React from 'react';
import { classNames } from '../../functions/classNames';
import { filterResource as filter } from '../../functions/filterResource';
import './Box.css';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';

const childrenWithResource = props => {
  return React.Children.map(props.children,
    child => React.cloneElement(child, {
      resource: props.resource,
      ...child.props,
    })
  );
};

const childrenWithValue = props => {
  return React.Children.map(props.children,
    child => React.cloneElement(child, {
      value: filter(props.value, child.props.name),
      handleChange: props.handleChange,
      error: filter(props.error, child.props.name),
      ...child.props,
    })
  );
};

export const SimpleBox = props => (
  <div className={classNames('Box', 'SimpleBox', props.className)} style={props.style}>
    <div className="content">{childrenWithResource(props)}</div>
  </div>
);

export const SimpleBoxEdit = props => (
  <div className={classNames('Box', 'SimpleBox', props.className)} style={props.style}>
    <div className="content">{childrenWithValue(props)}</div>
  </div>
);

export const BoxEdit = (props, context) => (
  <fieldset className={classNames('Box', props.className)} style={props.style}>
    <legend className="title">{getLabel(context.locale, props.label)}</legend>
    <div className="content">{childrenWithValue(props)}</div>
  </fieldset>
);

BoxEdit.contextTypes = {
  locale: PropTypes.string,
};

const Box = (props, context) => (
  <fieldset className={classNames('Box', props.className)} style={props.style}>
    <legend className="title">{getLabel(context.locale, props.label)}</legend>
    <div className="content">{childrenWithResource(props)}</div>
  </fieldset>
);

Box.contextTypes = {
  locale: PropTypes.string,
};

export default Box;



// WEBPACK FOOTER //
// ./src/main/components/container/Box.js